import { supabase } from "@/integrations/supabase/client";

export interface MarketingConfig {
  id: string;
  google_analytics_id: string | null;
  google_tag_manager_id: string | null;
  facebook_pixel_id: string | null;
  facebook_pixel_token: string | null;
}

export async function getMarketingConfig(): Promise<MarketingConfig | null> {
  const { data, error } = await supabase
    .from("configuracoes_marketing")
    .select("id, google_analytics_id, google_tag_manager_id, facebook_pixel_id, facebook_pixel_token")
    .limit(1)
    .single();

  if (error) throw new Error(error.message);
  return data as MarketingConfig;
}

export async function getPublicMarketingConfig(): Promise<Pick<MarketingConfig, "google_analytics_id" | "google_tag_manager_id" | "facebook_pixel_id"> | null> {
  const { data, error } = await (supabase as any)
    .from("marketing_public_config")
    .select("google_analytics_id, google_tag_manager_id, facebook_pixel_id")
    .limit(1)
    .single();

  if (error) return null;
  return data as Pick<MarketingConfig, "google_analytics_id" | "google_tag_manager_id" | "facebook_pixel_id">;
}

export async function updateMarketingConfig(
  id: string,
  updates: Partial<Pick<MarketingConfig, "google_analytics_id" | "google_tag_manager_id" | "facebook_pixel_id" | "facebook_pixel_token">>
) {
  const { error } = await supabase
    .from("configuracoes_marketing")
    .update(updates)
    .eq("id", id);

  if (error) throw new Error(error.message);
}
